import React from 'react';
import { snookerFrameStats } from '../utils/streamingStats';
import './StreamingStatsControls.css';

export default function StreamingStatsControls({ gameState, onCommand }) {
    const stats = snookerFrameStats(gameState);
    return (
        <section className="streaming-stats-controls" aria-label="Streaming statistics controls">
            <div>
                <span className="ref-eyebrow">BROADCAST</span>
                <h3>Streaming stats</h3>
                <div className="streaming-stats-preview">
                    <p>{`Preview for ${stats.player}`}</p>
                    <div className="streaming-stats-values">
                        <div><span>{stats.label}</span><strong>{stats.difference}</strong></div>
                        <div><span>Remaining</span><strong>{stats.remaining ?? '—'}</strong></div>
                        <div><span>Reds</span><strong>{stats.reds ?? '—'}</strong></div>
                    </div>
                </div>
            </div>
            <div className="streaming-stats-control-buttons">
                <button disabled={gameState.frameOver || gameState.isGameFinished} onClick={() => onCommand('show')}>Show stats · 10s</button>
                <button onClick={() => onCommand('hide')}>Hide stats</button>
                <button onClick={() => onCommand('resume')}>Resume schedule</button>
            </div>
            <p className="streaming-stats-help">Shows on the stream, not the room scoreboard. Hide pauses the display; Resume returns to your saved schedule.</p>
        </section>
    );
}
